import {
  CHECK_BOX_MSG,
  ConditionalField,
  CreateDynamicSchema,
  FieldConfig,
  OPTION_MSG,
  RequiredField,
} from "./formik";

const deliveredDamagesFollowUpConfig: FieldConfig[] = [
  RequiredField("wasCorrectDeliveryStatusEntered", OPTION_MSG),
  RequiredField("confirmDeliveryCodeMatchesADE", OPTION_MSG),
  RequiredField("confirmDriverTookValidEPs", OPTION_MSG),
  RequiredField("f18Note"),
];

export const DeliveredDamagesFollowUpSchema = CreateDynamicSchema(
  deliveredDamagesFollowUpConfig
);

export const INIT_DELIVERED_DAMAGES_FOLLOW_UP_FORM_VALUE = {
  wasCorrectDeliveryStatusEntered: undefined,
  confirmDeliveryCodeMatchesADE: undefined,
  confirmDriverTookValidEPs: undefined,
  f18Note: undefined,
};

const config: FieldConfig[] = [
  RequiredField("wasCorrectDeliveryStatusEntered", OPTION_MSG),
  RequiredField("confirmDeliveryCodeMatchesADE", OPTION_MSG),
  RequiredField("confirmDriverTookValidEPs", OPTION_MSG),
  RequiredField(
    "checkSpecialInstructions",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  ConditionalField("specialInstructionsDetails", "checkSpecialInstructions"),
  RequiredField("isAllProductDamaged", OPTION_MSG),
  { name: "shipmentConsistsOf", type: "string" },
  { name: "productDescription", type: "string" },
  { name: "packageType", type: "string" },
  { name: "isPackageDamaged", type: "string" },
  { name: "isProductDamaged", type: "string" },
  { name: "isProductNotDamaged", type: "string" },
  { name: "isPackageRepairable", type: "string" },
  { name: "areValidPicturesAvailable", type: "string" },
  ConditionalField(
    "willConsigneeAcceptRedelivery",
    "isAllProductDamaged",
    "N",
    true,
    OPTION_MSG
  ),

  ConditionalField("consigneePhone", "willConsigneeAcceptRedelivery"),
  ConditionalField("consigneeEmail", "willConsigneeAcceptRedelivery"),
  ConditionalField("consigneeName", "willConsigneeAcceptRedelivery"),
  ConditionalField(
    "canProductBeRecouped",
    "isAllProductDamaged",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "reasonWhyCannotBeRecouped",
    "canProductBeRecouped",
    "N",
    true,
    OPTION_MSG
  ),

  ConditionalField(
    "canProductBeRecouped",
    "isAllProductDamaged",
    "N",
    true,
    OPTION_MSG
  ),
  RequiredField("checkPhotos", CHECK_BOX_MSG, true, "string", true),
  RequiredField("updatedF18Notes", CHECK_BOX_MSG, true, "string", true),
  RequiredField("f18Note"),
];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const PRInvestigationSchema = CreateDynamicSchema(config);

const followUpconfig: FieldConfig[] = [
  RequiredField("doesShipperWantFreightBack", OPTION_MSG),
  ConditionalField(
    "clearShipmentStatusRCN",
    "doesShipperWantFreightBack",
    "Y",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  ConditionalField(
    "valueRangeFollowUp",
    "doesShipperWantFreightBack",
    "N",
    true,
    OPTION_MSG,
  ),

  ConditionalField(
    "didRcpmApproveDumpBill",
    "doesShipperWantFreightBack",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "wasReturnAuthorizationReceived",
    "doesShipperWantFreightBack",
    "N",
    true,
    OPTION_MSG
  ),

  ConditionalField("freightBackDetails", "doesShipperWantFreightBack", "N"),
  RequiredField("f18Note2"),
];
export const damageFollowUpSchema = CreateDynamicSchema(followUpconfig);

export const INIT_PR_INVESTIGATION_FORM_VALUE = {
  wasCorrectDeliveryStatusEntered: undefined,
  confirmDeliveryCodeMatchesADE: undefined,
  confirmDriverTookValidEPs: undefined,
  checkSpecialInstructions: undefined,
  specialInstructionsDetails: undefined,
  isAllProductDamaged: undefined,
  canProductBeRecouped: undefined,
  willConsigneeAcceptRedelivery: undefined,
  checkPhotos: undefined,
  updatedF18Notes: undefined,
  doesShipperWantFreightBack: undefined,
  clearShipmentStatusRCN: undefined,
  valueRangeFollowUp: undefined,
  didRcpmApproveDumpBill: undefined,
  wasReturnAuthorizationReceived: undefined,
  shipmentConsistsOf: undefined,
  productDescription: undefined,
  packageType: undefined,
  isPackageDamaged: undefined,
  isProductDamaged: undefined,
  isProductNotDamaged: undefined,
  isPackageRepairable: undefined,
  areValidPicturesAvailable: undefined,
  reasonWhyCannotBeRecouped: undefined,
  consigneePhone: undefined,
  consigneeEmail: undefined,
  freightBackDetails: undefined,
  consigneeName: undefined,
  f18Note: undefined,
};

export const INIT_DAMAGE_FOLLOW_UP_FORM_VALUE = {
  doesShipperWantFreightBack: undefined,
  freightBackDetails: "",
  clearShipmentStatusRCN: undefined,
  valueRangeFollowUp: undefined,
  didRcpmApproveDumpBill: undefined,
  wasReturnAuthorizationReceived: undefined,
  f18Note2: undefined,
};
